<template>
  <div id="search-results" class="xcontainer">
    <template v-if="activeTab === 'developers'">
      <developer-index class="mb-16" :request-data="requestData">
        <template #header>
          <h1 class="mt-0 mb-0">Results for “{{ searchQuery }}”</h1>
          <search-tabs :active-tab="activeTab" />
        </template>
      </developer-index>
    </template>
    <template v-if="activeTab === 'plugins'">
      <plugin-index
        action="searchPlugins"
        :request-data="requestData"
        :disable-sorting="true"
      >
        <template #header>
          <div>
            <h1 class="mt-0 mb-0">Results for “{{ searchQuery }}”</h1>

            <search-tabs :active-tab="activeTab" />
          </div>
        </template>
      </plugin-index>
    </template>
  </div>
</template>

<script setup lang="ts">
  import PluginIndex from '../../components/PluginIndex.vue';
  import DeveloperIndex from '../../components/DeveloperIndex.vue';
  import SearchTabs from '../../components/SearchTabs.vue';
  import {
    definePageMeta,
    useRoute,
    useAsyncData,
    computed,
    useAppStore,
    usePluginIndexStore,
    createError,
  } from '#imports';

  definePageMeta({
    layout: 'site',
  });

  const appStore = useAppStore();
  const pluginIndexStore = usePluginIndexStore();

  const route = useRoute();

  // Async Data
  const {error} = await useAsyncData(
    `search-plugins-${route.query.q}`,
    async () => {
      const _searchQuery = route.query.q;

      await pluginIndexStore
        .searchPlugins({
          _searchQuery,
          disableSorting: true,
        })
        .catch((thrown) => {
          throw createError({message: thrown});
        });

      appStore.updatePageMeta({
        title: `${_searchQuery} - Craft Plugins Search`,
        description: `Search results for “${_searchQuery}”.`,
      });
    },
  );

  if (error.value) {
    throw error.value;
  }

  // Computed
  const searchQuery = computed(() => route.query.q);
  const requestData = computed(() => {
    return {
      searchQuery: searchQuery.value,
    };
  });
  const activeTab = computed(() => {
    if (route.query && route.query.tab) {
      return route.query.tab;
    }

    return 'plugins';
  });
</script>
